const ProfileView = () => import('@/views/profile/ProfileView.vue')
const ProfileEdit = () => import('@/views/profile/ProfileEdit.vue')

export const profileRoutes = [
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView,
    meta: {
      requireAuth: true,
      title: 'Profile'
    }
  },
  {
    path: '/profile/edit',
    name: 'EditProfile',
    component: ProfileEdit,
    meta: {
      requireAuth: true,
      title: 'Edit Profile'
    }
  }
]
